
import { Zap, Target, Clock, Database, CheckCircle } from "lucide-react";
import { cn } from "@/lib/utils";

interface ValueProposition {
  icon: React.ReactNode;
  text: string;
}

interface WhyChooseUsProps {
  className?: string;
  showTitle?: boolean;
  valueProps?: ValueProposition[];
  condensed?: boolean;
}

export const defaultValueProps = [
  {
    icon: <Clock className="h-5 w-5 text-primary mr-2" />,
    text: "Save 4+ hours per campaign"
  },
  {
    icon: <Target className="h-5 w-5 text-primary mr-2" />,
    text: "AI-optimized keyword relevance"
  },
  {
    icon: <Database className="h-5 w-5 text-primary mr-2" />,
    text: "Automated reporting"
  },
  {
    icon: <Zap className="h-5 w-5 text-primary mr-2" />,
    text: "Brand-specific AI assistants"
  },
  {
    icon: <CheckCircle className="h-5 w-5 text-primary mr-2" />,
    text: "Complete transparency"
  }
];

const WhyChooseUs = ({
  className,
  showTitle = true,
  valueProps = defaultValueProps,
  condensed = false
}: WhyChooseUsProps) => {
  return (
    <div className={cn("w-full", className)}>
      {showTitle && (
        <h2 className="text-2xl font-bold text-center mb-4">Why Choose Upfixe?</h2>
      )}
      
      <div className={cn(
        "flex flex-wrap justify-center gap-4",
        condensed ? "flex-col sm:flex-row" : "flex-col md:flex-row"
      )}>
        {valueProps.map((prop, index) => (
          <div 
            key={index} 
            className={cn(
              "flex items-center bg-primary/10 px-4 py-2 rounded-full",
              condensed ? "text-sm" : ""
            )}
          >
            {prop.icon}
            <span className="font-medium">{prop.text}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WhyChooseUs;
